// Roof types replace the old Good/Better/Best tiers. The type code keys the
// estimate variants, proposal tiers and selected_tier. Old GOOD/BETTER/BEST keys
// are kept in the maps so previously-saved proposals still render.
export const ROOF_TYPES = ["SHINGLE", "METAL", "TILE", "FLAT"];

export const ROOF_TYPE_LABEL = {
  SHINGLE: "Shingle", METAL: "Metal", TILE: "Tile", FLAT: "Flat / Low-Slope",
  GOOD: "Good", BETTER: "Better", BEST: "Best",
};

// roof type -> roofCatalog.js category (for brand/product/color selection)
export const ROOF_TYPE_CAT = { SHINGLE: "Shingle", METAL: "Metal", TILE: "Slate & Tile", FLAT: "Flat" };

export const ROOF_TYPE_DESC = {
  SHINGLE: "Architectural asphalt shingle", METAL: "Standing seam metal",
  TILE: "Clay / concrete tile", FLAT: "TPO / flat membrane",
};
export const ROOF_TYPE_SUB = {
  SHINGLE: "Most popular — great value", METAL: "Lifetime, energy efficient",
  TILE: "Premium, long-lasting", FLAT: "For low-slope sections",
};
export const ROOF_TYPE_TONE = {
  SHINGLE: "bg-navy", METAL: "bg-slate-600", TILE: "bg-brandred", FLAT: "bg-slate-800",
  GOOD: "bg-slate-600", BETTER: "bg-navy", BEST: "bg-brandred",
};

export const tLabel = (t) => ROOF_TYPE_LABEL[t] || t;

export const systemName = (s, i) => s.label || `${tLabel(s.roof_type)} Roof${i != null ? ` ${i + 1}` : ""}`;

// "Shingle 30 sq + Metal 5 sq" for multi-system proposals, else the single roof type
export const proposalTypeLabel = (p) => (p.systems?.length
  ? p.systems.map((s) => `${tLabel(s.roof_type)} ${s.squares || 0} sq`).join(" + ")
  : tLabel(p.selected_tier));
